import React, { useEffect, useState } from 'react'
import { getVideosFromFirestore } from '../apis/firebase'
import Video from './Video'

export default function Videos() {
  const [videos, setVideos] = useState([])

  useEffect(() => {

    const fetchVideos = async () => {
      const fetchVideos = await getVideosFromFirestore()
      setVideos(fetchVideos[0].videos)
      console.log(fetchVideos[0].videos)
      

    }
    fetchVideos()
    

  }, [])

  return (
    <div className='secondary-blue center'>
      <div className='container'>
        <h1 className='yellowtext'>Latest videos/highlights</h1>
        <p className='yellowtext infotext'>My best / funniest moments may end up as shorts on YouTube, Instagram and TikTok. Look at my recent clips here!</p>
      </div>
      <div className='row'>
        { videos.length > 0 && videos.map((video) => (
          <a href={'https://www.youtube.com/watch?v=' + video.id.videoId} target='_blank' rel='noreferrer'><div className='col m4 s12' key={video.id.videoId}>
            <Video video={video}/>
          </div></a>
        ))}
      </div>
      <br/>
    </div>
  )
}
